const STATE_ID = 1;
const STATE_KEY = 'ai_enhancement_status_state';
const PROCESSING_LABEL_ID = 2;
const PROCESSING_LABEL_KEY = 'ai_enhancement_status_processing_label';
const AI_QUESTION1_ID = 3;
const AI_QUESTION1_KEY = 'ai_question_1';
const AI_QUESTION2_ID = 4;
const AI_QUESTION2_KEY = 'ai_question_2';
const NEXT_BUTTON_ID = 5;
const NEXT_BUTTON_KEY = 'ai_enhancement_status_next_button';
const EXPLANATION_TEXT_ID = 6;
const EXPLANATION_TEXT_KEY = 'ai_enhancement_status_explanation_text';

export {
	STATE_ID,
	AI_QUESTION1_ID,
	AI_QUESTION2_ID,
	NEXT_BUTTON_ID,
	PROCESSING_LABEL_ID,
	STATE_KEY,
	AI_QUESTION1_KEY,
	AI_QUESTION2_KEY,
	NEXT_BUTTON_KEY,
	PROCESSING_LABEL_KEY,
	EXPLANATION_TEXT_ID,
	EXPLANATION_TEXT_KEY,
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/constants.js